import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { 
  Router, 
  UrlTree, 
  CanActivateFn,
  RedirectCommand
} from '@angular/router';
import { getAuthToken, setAuthToken } from '../../interceptors/api.interceptor';
import { UserService } from '../services/user_service';
import { Observable } from 'rxjs';
// import Debug from 'debug';

// const debug = Debug('notd:AuthGuard');

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree | RedirectCommand> | boolean | UrlTree | RedirectCommand => {
  const userService = inject(UserService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  
  const isLoggedIn = userService.isLoggedIn();
  let shouldAttemptOAuthFlow = false;

  if (isPlatformBrowser(platformId)) {
    shouldAttemptOAuthFlow = 
      !isLoggedIn &&
      !!userService.getParameterByName('state') &&
      !!userService.getParameterByName('code') &&
      !getAuthToken();
  } 

  return new Promise<boolean | UrlTree | RedirectCommand>(resolve => {
    if (shouldAttemptOAuthFlow) {
      // debug('runOAuth');
      userService.runOAuth().then(response => {
        if (!response || !response.headers) {
          resolve(false);
          return;
        }

        const token = response.headers.get('Notd-Auth');

        if (!token) {
          resolve(false);
          return;
        }
        // debug('got token', token);
        setAuthToken(token);

        return userService.getProfile()
          .then(() => resolve(true))
          .catch(() => resolve(false));
      });
    } else if (!isLoggedIn) {
      if (isPlatformBrowser(platformId)) {
        resolve(new RedirectCommand(router.parseUrl('/')));
        return;
      }
      resolve(false);
    } else {
      resolve(true);
    }
  });
};